import JsBarcode from "jsbarcode";
import {formatDate, formatMoney} from "./returnsApi";

const escapeHtml = (value) =>
    String(value ?? "").replace(/[&<>"']/g, (c) => ({
        "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
    }[c]));

// Opens a print window with an 80 mm receipt-style avoir (code "28…", EAN-13,
// scanned at the POS payment step). Same layout as the ticket printed by the
// tablet when the avoir is issued — used here to reprint a lost one.
export const printCreditNote = ({note, shopName}) => {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    try {
        JsBarcode(svg, note.code, {format: "EAN13", height: 60, width: 2, fontSize: 16, margin: 4});
    } catch (e) {
        JsBarcode(svg, note.code, {format: "CODE128", height: 60, width: 2, margin: 4});
    }

    const win = window.open("", "_blank", "width=420,height=640");
    if (!win) return false;
    win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Avoir ${escapeHtml(note.code)}</title>
<style>
  @page { size: 80mm auto; margin: 4mm; }
  body { margin: 0; font-family: Arial, sans-serif; width: 72mm; color: #000; }
  .center { text-align: center; }
  .shop { font-size: 13pt; font-weight: bold; }
  .title { font-size: 18pt; font-weight: bold; letter-spacing: 2px; margin: 4mm 0 2mm; }
  .amount { font-size: 22pt; font-weight: bold; margin: 2mm 0 4mm; }
  .row { display: flex; justify-content: space-between; font-size: 10pt; margin: 1mm 0; }
  .muted { font-size: 8pt; color: #333; margin-top: 4mm; }
  hr { border: none; border-top: 1px dashed #000; margin: 3mm 0; }
  svg { width: 100%; height: auto; }
</style></head><body>
  <div class="center shop">${escapeHtml(shopName)}</div>
  <div class="center title">AVOIR</div>
  <div class="center amount">${escapeHtml(formatMoney(note.amount))}</div>
  ${svg.outerHTML}
  <hr/>
  <div class="row"><span>Émis le</span><span>${escapeHtml(formatDate(note.created_at))}</span></div>
  <div class="row"><span>Valable jusqu'au</span><span>${note.expires_at ? escapeHtml(formatDate(note.expires_at)) : "Sans limite"}</span></div>
  ${note.client ? `<div class="row"><span>Client</span><span>${escapeHtml(note.client.name)}</span></div>` : ""}
  <hr/>
  <div class="center muted">À présenter en caisse. Utilisable en une seule fois ;
  le reste éventuel est rendu sous forme d'un nouvel avoir. Ni remboursable ni échangeable contre des espèces.</div>
<script>window.onload = function () { window.print(); };</script></body></html>`);
    win.document.close();
    return true;
};
